import { useState, useEffect, useCallback } from 'react';
import { read_cookie } from "sfcookies";
import { hostUrl, UseUrlManagerCleanUrl } from "../../../../../utils/url-manager";

export const useAdminCheckoutCustomerSession: () => {
    loadingCheckout: boolean,
    checkoutSession: { clientSecret: string },
    fetchCheckoutSession: any,
    error: string,
    expireCheckoutSession: any
} = (): {
    loadingCheckout: boolean,
    checkoutSession: { clientSecret: string },
    fetchCheckoutSession: any,
    error: string,
    expireCheckoutSession: any
} => {
    const [loadingCheckout, setLoadingCheckout] = useState<boolean>(true);
    const [checkoutSession, setCheckoutSession] = useState<{ clientSecret: string }>();
    const [error, setError] = useState<string>('');

    function fetchCheckoutSession(payload: any): void {
        const url: string = UseUrlManagerCleanUrl({ url: hostUrl + 'hq/checkout/prepare/session' })
        const request: Request = new Request(url, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: new Headers({
                'Content-Type': 'application/json',
                'token': read_cookie('auth')
            })
        });
        fetch(request)
            .then( (response: Response): Promise<any> => {
                return response.json();
            } )
            .then( (data: any): void => {
                setLoadingCheckout(false);
                if (data?.status === 'success') {
                    let datum: { clientSecret: string } = {
                        clientSecret: data?.checkout_session
                    };
                    setCheckoutSession(datum);
                }
                if (data?.status === 'error') {
                    setError(data?.message);
                }
                console.log(data);
            } )
            .catch( (err: Error): void => {
                console.log(err);
            })
    }

    function expireCheckoutSession(): void {
        if (checkoutSession !== undefined) {
            const url: string = UseUrlManagerCleanUrl({ url: hostUrl + 'hq/checkout/expire/session' })
            const request: Request = new Request(url, {
                method: 'POST',
                body: JSON.stringify({ id: checkoutSession?.clientSecret }),
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'token': read_cookie('auth')
                })
            });
            fetch(request)
                .then( (response: Response): Promise<any> => {
                    return response.json();
                } )
                .then( (data: any): void => {
                    // Do nothing as session either expires from request
                    // or by default timeout.
                } )
                .catch( (err: Error): void => {
                    console.log(err);
                })
        }

    }


    return { loadingCheckout, checkoutSession, fetchCheckoutSession, error, expireCheckoutSession };
}